import { Fragment, useContext } from 'react';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import useSelectionSummary from 'components/ScalarSpreadsheet/hooks/useSelectionSummary';
import { SELECTION_SUMMARY_BAR_ITEMS } from './constants';
import { SelectionSummaryBarProps } from './SelectionSummaryBar.props';
import { classes, Root } from './SelectionSummaryBar.styles';
import { formatValue } from './utils';

const SelectionSummaryBar = ({ selectedCell, data, useCellCurrencyFormat }: SelectionSummaryBarProps) => {
  const { format } = useContext(FeaturedSpreadsheetContext);
  const exchangeRate = format?.currency?.exchangeRate;
  const units = format?.currency?.units;
  const summary = useSelectionSummary(selectedCell, data, exchangeRate, units, useCellCurrencyFormat);

  if (!summary) {
    return null;
  }

  return (
    <Root className={classes.root} data-testid="selection-summary-bar">
      {SELECTION_SUMMARY_BAR_ITEMS.map((item, index) => (
        <Fragment key={item.key}>
          {index > 0 && <span className={classes.divider}>|</span>}
          <span className={classes.item}>
            <span className={classes.label}>{item.label}:</span>
            <span className={classes.value}>{formatValue(summary[item.key])}</span>
          </span>
        </Fragment>
      ))}
    </Root>
  );
};

export default SelectionSummaryBar;
